const fonts = {
  regular: "'ProximaNova', Arial, helvetica",
  italic: "'ProximaNovaRegularIt', Arial, helvetica",
  bold: "'ProximaNovaBold', Arial, helvetica",
  light: "'ProximaNovaLight', Arial, helvetica"
}

export default fonts
